import { useCore } from '@/composables/core/index.js'
import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('can-use-frontdesk')

export default function (route, from, next) {
  logger.debug(route.path)

  // business route
  const br = route.matched.find(r => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!br) {
    return next()
  }

  const { store } = useCore()
  const business = store.state.business.business

  if ((business && !business.can_use_frontdesk) && route.name !== 'forbidden') {
    logger.debug('redirecting to "forbidden" view...')
    return next({
      name: 'forbidden',
      params: { businessId: business.id },
      query: { reason: 'business-is-inactive' },
    })
  }

  next()
}
